module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Fislisbach-a31cd78bb6c06585553a92b5b2dfd727.svg";